import { useContext } from 'react';
import type { IAppPayloadContext } from '../components/AppPayloadProvider/AppPayloadContext';
import AppPayloadContext from '../components/AppPayloadProvider/AppPayloadContext';

export default function useAppPayload(): IAppPayloadContext {
  return useContext(AppPayloadContext);
}
